import { useState, useEffect, useRef } from 'react'

const MENU_WIDTH = 208 // w-52 = 13rem = 208px
const MENU_HEIGHT = 200 // approximate height

export function useContextMenu() {
  const [contextMenu, setContextMenu] = useState<{ x: number; y: number } | null>(null)
  const contextMenuRef = useRef<HTMLDivElement>(null)

  // Handle right-click context menu
  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    // Calculate position ensuring menu stays within viewport
    let x = e.clientX
    let y = e.clientY

    // Adjust if menu would go off right edge
    if (x + MENU_WIDTH > window.innerWidth) {
      x = window.innerWidth - MENU_WIDTH - 10
    }

    // Adjust if menu would go off bottom edge
    if (y + MENU_HEIGHT > window.innerHeight) {
      y = window.innerHeight - MENU_HEIGHT - 10
    }

    setContextMenu({ x, y })
  }

  // Close context menu
  const closeContextMenu = () => {
    setContextMenu(null)
  }

  // Close context menu when clicking outside or pressing escape
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (contextMenuRef.current && !contextMenuRef.current.contains(e.target as Node)) {
        closeContextMenu()
      }
    }

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeContextMenu()
      }
    }

    if (contextMenu) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('keydown', handleEscape)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
        document.removeEventListener('keydown', handleEscape)
      }
    }
  }, [contextMenu])

  return {
    contextMenu,
    contextMenuRef,
    handleContextMenu,
    closeContextMenu
  }
}
